module.exports = __webpack_public_path__ + "img/1.114741dc.jpg";